import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import createWholesaler from '@/API/Wholesaler/createWholesaler';
import { transformFormDataForCreate } from '../utils/wholesalerFormUtils';

const useCreateWholesaler = (formData, onSuccess) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            const response = await createWholesaler(
                transformFormDataForCreate(formData),
            );
            return response.data;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['wholesalers'] });
            toast.success('Wholesaler created successfully');
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (error?.response?.data?.errors) {
                const errorMessages = Object.values(error.response.data.errors)
                    ?.flat()
                    .join('\n');
                toast.error(errorMessages);
            } else {
                toast.error(
                    error?.response?.data?.message ||
                        error?.message ||
                        'Could not create Wholesaler at this time.',
                );
            }
        },
        staleTime: 0,
    });
};

export default useCreateWholesaler;
